const LOAD_DETAIL_BANK_ACCOUNT          = 'LOAD_DETAIL_BANK_ACCOUNT'
const LOAD_DETAIL_BANK_ACCOUNT_SUCCESS   = 'LOAD_DETAIL_BANK_ACCOUNT_SUCCESS'
const LOAD_DETAIL_BANK_ACCOUNT_FAILED    = 'LOAD_DETAIL_BANK_ACCOUNT_FAILED'
const UNMOUNT_DETAIL_BANK_ACCOUNT       = 'UNMOUNT_DETAIL_BANK_ACCOUNT'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const bankAccountDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_BANK_ACCOUNT:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_BANK_ACCOUNT_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_BANK_ACCOUNT_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_BANK_ACCOUNT:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default bankAccountDetailReducer;